import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(({
  palette, colors, spacing, breakpoints,
}: Theme) => createStyles({
  modal: {
    // border: `2px solid ${colors.border}`,
  },
  closeButton: {
    position: 'absolute',
    right: spacing(1),
    top: spacing(1),
    color: palette.grey[500],
  },
  dialogContent: {
    padding: spacing(3),
  },
  cancelButton: palette.cancelAction,
  buttonIcon: {
    width: '18px',
    height: '18px',
    verticalAlign: 'middle',
    marginTop: -2,
    marginRight: 5,
  },
  buttonText: {
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: 600,
    letterSpacing: '0.21px',
    textTransform: 'none',
    paddingLeft: '0.25em',
    lineHeight: 'initial',
    [breakpoints.down(500)]: {
      fontSize: '12px',
    },
  },
  panelButton: {
    height: '36px',
    minWidth: '128px',
    '& > span:first-child': {
      paddingTop: '2px',
      paddingBottom: '2px',
    },
    '&:hover': {
      backgroundColor: 'brightness(150%)',
    },
  },
  dialogActions: {
    borderTop: `1px solid ${colors.border}`,
    justifyContent: 'space-between',
    padding: '18px 25px',
  },
  reactFormDialogActions: {
    flexDirection: 'row-reverse',
  },
  stepModalDialogActions: {
    justifyContent: 'space-between !important',
    flexDirection: 'row-reverse',

    '& button': {
      width: 148,
      [breakpoints.down(500)]: {
        width: 100,
      },
    },
  },
  singleAction: {
    justifyContent: 'flex-end',
  },
  input: {
    marginBottom: 24,
  },
  stepModalStepper: {
    padding: '0 0 48px 0',
    '& .MuiStepConnector-root': {
      flex: 'none',
      width: 30,
    },

    '& .MuiStep-root:first-child': {
      paddingLeft: 0,
    },

    '& .MuiStepIcon-root': {
      color: '#DCDEE5',
    },
    '& .MuiStepIcon-root.MuiStepIcon-active': {
      color: '#01B3C5',
    },

    '& .MuiStepIcon-root.MuiStepIcon-completed': {
      color: '#747C99',
    },

    '& .MuiStepLabel-label': {
      fontSize: 12,
      color: '#515B6A',
    },
  },
  stepModalDialogContent: {
    paddingTop: '0 !important',

    '&::-webkit-scrollbar': {
      width: '0.4em',
      height: 5,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.28)',
      borderRadius: 5,
    },
  },
  stepModalContainer: {
    width: '100%',
  },
  formContent: {
    display: 'flex',
    flexDirection: 'column',
    // height: 'calc(100% - 10px)',
  },
  button: {
    marginRight: 8,
  },
  instructions: {
    marginTop: 8,
    marginBottom: 8,
  },
  backButton: {
    background: '#F1F2F5',
  },
  nextButton: {
    '&:hover': {
      backgroundColor: palette.buttonAction.background,
    },
    disabled: palette.disabledButton,
  },
  stepModalPaper: {
    width: '100%',
    maxWidth: 700,
    display: 'flex',

    [breakpoints.down(700)]: {
      margin: 0,
      maxHeight: '100%',
      height: '100vh',
      borderRadius: 0,
    },
  },
}), { name: 'ModalForm' });

export default useStyles;
